export function transformLegacyPath(path: string): string {
  if (!path) {
    return path;
  }

  if (path.startsWith('/group/')) {
    return path.replace('/group/', '/home/group/');
  }
  if (path === '/group') {
    return '/home/profile/my-groups';
  }
  if (path.startsWith('/detail-activity/')) {
    return path.replace('/detail-activity/', '/home/detail-activity/');
  }
  if (path === '/detail-activity') {
    return '/home/detail-activity';
  }
  if (path === '/explore') {
    return '/home/explore';
  }

  return path;
}

export function isLegacyRoute(path: string): boolean {
  if (!path) {
    return false;
  }
  return (
    path === '/group' ||
    path.startsWith('/group/') ||
    path === '/detail-activity' ||
    path.startsWith('/detail-activity/') ||
    path === '/explore'
  );
}
